<template>
  <!-- 
    name: 覃刚
    function: 原料数据库-新增
    date: 2021-03-15
 -->
  <div>
    <div class="nurientHead">
      <div class='left'>
        <a-input-search placeholder="指标名称/全称/代码" @search="onSearch">
          <a-button slot="enterButton">
            搜索
          </a-button>
        </a-input-search>
      </div>
      <div class="middle"></div>
      <div class="right">
        <a-input placeholder="选择指标类型" />
      </div>
    </div>
    <a-table :columns="columns" :data-source="list" class="tableBox" :row-selection="rowSelection">
    </a-table>
  </div>
</template>
<script>
export default {
  data(){
    return {
      name: 'ddd',
      form: this.$form.createForm(this, {
        note: 'dddd',
        gender: 1
      }),
      selectList:[],
      list:[
        {
          edit: false,
          key: '1',
          name: 'John Brown',
          name2: 'John Brown',
          name3: 'John Brown',
          name4: 'John Brown',
          name5: 'John Brown',
          name6: 'John Brown',
          name7: 'John Brown'
        },
        {
          edit: true,
          key: '2',
          name: 'John Brown2',
          name2: 'John Brown2',
          name3: 'John Brown2',
          name4: 'John Brown2',
          name5: 'John Brown2',
          name6: 'John Brown2',
          name7: 'John Brown2'
        }
      ],
      columns: [
        {
          title: '全称',
          dataIndex: 'name'
        },
        {
          title: '代码',
          dataIndex: 'name2'
        },
        {
          title: '指标名称',
          dataIndex: 'name3'
        },
        {
          title: '类型',
          dataIndex: 'name4'
        },
        {
          title: '单位',
          dataIndex: 'name5'
        }
      ],
      rowSelection:{
        onChange: (selectedRowKeys, selectedRows) => {
          console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
          this.selectList = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {
          console.log(record, selected, selectedRows);
          this.selectList = selectedRows
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
          console.log(selected, selectedRows, changeRows);
          this.selectList = selectedRows
        }
      }
    }
  },
  methods:{
    onSearch(){
      console.log('查询指标')
    },
    handleSelectChange(value) {
      console.log(value);
      // console.log(this.formData)
      this.form.setFieldsValue({
        note: `Hi, ${value === 'male' ? 'man' : 'lady'}!`,
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.nurientHead{
  display: flex;
  .left,.right{
    width: 40%;
  }
  .middle{
    width: 20%;
  }
}
.tableBox{
  padding: 0;
  margin-top: 20px;
}
</style>